import * as React from 'react';
import { Eye, EyeOff } from 'lucide-react';

export interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
  { className, ...props },
  ref
) {
  const [visible, setVisible] = React.useState(false);

  return (
    <div className="password-input">
      <input
        ref={ref}
        className={['input', 'password-input__field', className].filter(Boolean).join(' ')}
        type={visible ? 'text' : 'password'}
        {...props}
      />
      <button
        type="button"
        className="password-input__toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
      >
        {visible ? <EyeOff className="password-input__icon" /> : <Eye className="password-input__icon" />}
      </button>
    </div>
  );
});
